import {
  NOT
} from '../../../lib/Boolean.lib';
import Core from '../../../lib/Core';
import {
  ID__ATS_TYPE__GH_HARVEST,
  ID__ATS_TYPE__GH_INGESTION
} from '../../../lib/Definition';
import {
  Fun
} from '../../../lib/Function.lib';
import useState from '../../../lib/hooks/useState.hook';
import getAtsContextProperty from '../../../lib/services/ATS/getAtsContextProperty.fun';
import getAtsContextUpdated from '../../../lib/services/ATS/getAtsContextUpdated.fun';
import Greenhouse from '../../../lib/services/ATS/Greenhouse.lib';
import {
  trim
} from '../../../lib/String.lib';
import Box from '../../Layout/Wrappers/Box';
import Button from '../../Layout/Wrappers/Button';
import Col from '../../Layout/Wrappers/Col';
import Fieldset from '../../Layout/Wrappers/Fieldset';
import TextField from '../../Layout/Wrappers/TextField';
import {
  Label
} from '../../Layout/Wrappers/Typography';

export default function SubSectionAtsSettingsGreenhouse({
  acl = true,
  entity = {},
  onChange = Fun,
  ...props
}) {

  const [state, updateState] = useState();

  if (NOT(acl)) { return null; }

  const {
    validatingConnection = false,
    atsSourceNameWarning,
    atsUserNameWarning,
    atsUserIdWarning,
  } = state;

  const atsTypeId = parseInt(entity.atsTypeId);

  const isAtsGhHarvestSelected = (
    atsTypeId === ID__ATS_TYPE__GH_HARVEST
  );

  const isAtsGhIngestionSelected = (
    atsTypeId === ID__ATS_TYPE__GH_INGESTION
  );

  const VALUE__ATS__API_KEY = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'apiKey'
  })

  // GH: onBehalfOfEmployerUserEmail
  const VALUE__ATS__USER__EMAIL__GH = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'onBehalfOfEmployerUserEmail'
  });

  // GH: onBehalfOfEmployerUserId
  const VALUE__ATS__USER__ID__GH = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'onBehalfOfEmployerUserId'
  });

  // GH: onBehalfOfEmployerUserName
  const VALUE__ATS__USER__NAME__GH = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'onBehalfOfEmployerUserName'
  });

  // GH: agencyName
  const VALUE__ATS__AGENCY__NAME__GH = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'agencyName'
  });

  // GH: sourceIdAgencyId
  const VALUE__ATS__AGENCY__ID__GH = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'sourceIdAgencyId'
  });

  // GH: agencyRecruiterName
  const VALUE__ATS__AGENCY__RECRUITER__NAME__GH = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'agencyRecruiterName'
  });

  // GH: onBehalfOfEmployerUserDisabled
  const VALUE__ATS__USER__DISABLED__GH = getAtsContextProperty({
    entity,
    atsTypeId,
    property: 'onBehalfOfEmployerUserDisabled'
  });

  const isAtsValidateConnectionDisabled = !(
    !!VALUE__ATS__API_KEY?.trim() &&
    !!VALUE__ATS__AGENCY__NAME__GH?.trim() &&
    (!!VALUE__ATS__USER__NAME__GH?.trim() || !!VALUE__ATS__USER__ID__GH)
  );

  const isAtsUserInfoAvailable = (
    isAtsGhHarvestSelected &&
    (VALUE__ATS__USER__NAME__GH || VALUE__ATS__USER__ID__GH)
  );

  function onChangeTextField(field) {
    return async (event, value) => {
      await onChange(
        getAtsContextUpdated({
          entity,
          atsTypeId,
          update: {
            [field]: value
          }
        })
      );
    }
  }

  async function onClickValidateConnectionButton(event) {
    try {
      /**
       * Starting
       * - Set loading flag.
       * - Clean warning text.
       * - Clean state values to get from GH.
       */
      await updateValidations();

      /**
       * Make calls
       */
      let atsUser;
      if (trim(VALUE__ATS__USER__NAME__GH)) {
        atsUser = await getGreenhouseUserByName();
      }

      const atsUserId = VALUE__ATS__USER__ID__GH || atsUser?.id;
      if (!!atsUserId) {
        await getGreenhouseUserById({ atsUserId });
      }

      await getGreenhouseSourceId();

      /**
       * Done
       */
      updateState({
        validatingConnection: false
      });
    }
    catch { }

  }

  async function updateValidations(update) {
    if (update) {
      SubSectionAtsSettingsGreenhouse.validations = {
        ...SubSectionAtsSettingsGreenhouse.validations,
        ...update
      };
    }
    else {
      SubSectionAtsSettingsGreenhouse.validations = {};
      await updateState({
        validatingConnection: true,
        atsSourceNameWarning: null,
        atsUserNameWarning: null,
        atsUserIdWarning: null,
      });
      onChange(
        getAtsContextUpdated({
          entity,
          atsTypeId,
          update: {
            onBehalfOfEmployerUserName: null,
            onBehalfOfEmployerUserEmail: null,
            onBehalfOfEmployerUserDisabled: null,
            sourceIdAgencyId: null
          }
        })
      );
    }
  }

  function getGreenhouseUserByName() {
    return new Promise(async function (resolve, reject) {
      await updateState({ atsUserNameWarning: null });
      Greenhouse.harvest.getUserByName({
        apiKey: VALUE__ATS__API_KEY,
        userName: VALUE__ATS__USER__NAME__GH,
        async onSuccess(user) {
          if (!VALUE__ATS__USER__NAME__GH) {
            await onChangeTextField('onBehalfOfEmployerUserId')(
              null, user.id
            );
          }
          onChange(
            getAtsContextUpdated({
              entity,
              atsTypeId,
              update: {
                onBehalfOfEmployerUserName: user.name,
                onBehalfOfEmployerUserEmail: user.email,
                onBehalfOfEmployerUserDisabled: user.disabled
              }
            })
          );
          resolve(user);
        },
        onFailure: async (failures, suggestions, statusCode) => {
          onGreenhouseFailure(failures, suggestions, statusCode);
          await updateState({ atsUserNameWarning: failures[0] });
          reject({ failures, suggestions, statusCode });
        }
      });
    });
  }

  async function getGreenhouseUserById({ atsUserId }) {
    return await Greenhouse.harvest.getUserById({
      apiKey: VALUE__ATS__API_KEY,
      userId: atsUserId,
      async onSuccess({
        id,
        name,
        first_name,
        last_name,
        primary_email_address,
        updated_at,
        created_at,
        disabled,
        site_admin,
        emails = [],
        employee_id,
        linked_candidate_ids = [],
      }) {
        /**
          * @note
          * The Id is the important value for us,
          * so we will prefer the user got it by id,
          * over the one got it by name.
          * For that reason here is not a conditional,
          * as it is on getGreenhouseUserByName > onSuccess
          */
        await onChange(getAtsContextUpdated({
          entity,
          atsTypeId,
          update: {
            onBehalfOfEmployerUserName: name,
            onBehalfOfEmployerUserEmail: primary_email_address,
            onBehalfOfEmployerUserDisabled: disabled
          }
        }));
      },
      async onFailure(failures, suggestions, statusCode) {
        await updateState({
          atsUserIdWarning: `User not found, please review this user id is right.`
        });
        onGreenhouseFailure(failures, suggestions, statusCode);
      }
    });
  }

  async function getGreenhouseSourceId() {
    return await Greenhouse.harvest.getSourceId({
      apiKey: VALUE__ATS__API_KEY,
      agencyName: VALUE__ATS__AGENCY__NAME__GH,
      async onSuccess({
        sourceIdAgencyId = null,
        sourceName = ''
      }) {
        if (sourceName.toLowerCase() === VALUE__ATS__AGENCY__NAME__GH.toLowerCase()) {
          onChange(getAtsContextUpdated({
            entity,
            atsTypeId,
            update: {
              sourceIdAgencyId
            }
          }));
        }
        else {
          updateState({
            atsSourceNameWarning: `Found "${sourceName}" for agency name rather than one provided "${VALUE__ATS__AGENCY__NAME__GH}".`
          });
        }
      },
      onFailure: onGreenhouseFailure
    });
  }


  async function onGreenhouseFailure(failures, suggestions, statusCode) {

    await updateState({ validatingConnection: false });

    Core.dialog.open({
      title: `Greenhouse API connection failed`,
      message: (
        <>
          {(
            statusCode
              ? <h4>Error code: {statusCode}</h4>
              : ''
          )}
          <h4>Error messages:</h4>
          <small>
            <b>
              <pre>{failures.join('\n\n')}</pre>
            </b>
          </small>
          <h4>Suggestions for taking action:</h4>
          <small>
            <b>
              <i>
                <pre>{suggestions.join('\n')}</pre>
              </i>
            </b>
          </small>
        </>
      )
    });
  }

  return (
    <Box column {...props}>

      <Box row>

        {(isAtsGhHarvestSelected || isAtsGhIngestionSelected) && (
          <Fieldset
            title='API key'
            subtitle={
              <small>
                Authentication credential to ATS
              </small>
            }
          >
            <TextField
              name="_atsApiKey"
              value={VALUE__ATS__API_KEY}
              onChange={onChangeTextField('apiKey')}
              fullWidth
            />
          </Fieldset>
        )}

        {isAtsGhIngestionSelected && (
          <Fieldset
            title='On-Behalf-Of'
            subtitle='User name issuing this request'
          >
            <TextField
              name="_atsOnBehalfOf"
              value={VALUE__ATS__USER__ID__GH}
              onChange={onChangeTextField('onBehalfOfEmployerUser')}
              fullWidth
            />
          </Fieldset>
        )}

      </Box>

      {isAtsGhHarvestSelected && (
        <>

          <Box row>

            <Fieldset
              title='On-Behalf-Of'
              subtitle={
                <Box row>
                  <small>
                    Name of the user issuing this request.
                    {VALUE__ATS__USER__EMAIL__GH && (<>&nbsp;<b>({VALUE__ATS__USER__EMAIL__GH})</b></>)}
                  </small>
                  <small className="c-red">
                    {atsUserNameWarning}
                  </small>
                </Box>
              }
            >
              <TextField
                name="_atsOnBehalfOfName"
                value={VALUE__ATS__USER__NAME__GH}
                onChange={onChangeTextField('onBehalfOfEmployerUserName')}
                fullWidth
              />
            </Fieldset>

            <Fieldset
              title='On-Behalf-Of ID'
              subtitle={
                <Box row>
                  <small>
                    ID of the user issuing this request
                  </small>
                  <small className="c-red">
                    {atsUserIdWarning}
                  </small>
                </Box>
              }
            >
              <TextField
                name="_atsOnBehalfOfId"
                value={VALUE__ATS__USER__ID__GH}
                type="number"
                onChange={onChangeTextField('onBehalfOfEmployerUserId')}
                fullWidth
              />
            </Fieldset>

          </Box>

          <Box row>

            <Fieldset
              title='ATS Source'
              subtitle={
                <Box row>
                  <small>
                    Name of the ATS source to be credited for application creation
                  </small>
                  <small className="c-red">
                    {atsSourceNameWarning}
                  </small>
                </Box>
              }
            >
              <TextField
                name="_atsAgencyName"
                value={VALUE__ATS__AGENCY__NAME__GH}
                onChange={onChangeTextField('agencyName')}
                fullWidth
              />
            </Fieldset>

            {VALUE__ATS__AGENCY__ID__GH && (
              <Fieldset
                title='ATS Source ID'
                subtitle={
                  <small>
                    The ID of the source to be credited for application creation
                  </small>
                }
              >
                <TextField
                  name="_atsSourceId"
                  type="number"
                  value={VALUE__ATS__AGENCY__ID__GH}
                  onChange={onChangeTextField('sourceIdAgencyId')}
                  fullWidth
                />
              </Fieldset>
            )}

          </Box>

          <Box row>

            <Fieldset
              title='ATS Recruiter Name'
              subtitle={
                <small>
                  Recruiter name employer gave 10x10
                </small>
              }
            >
              <TextField
                name="_atsAgencyRecruiterName"
                value={VALUE__ATS__AGENCY__RECRUITER__NAME__GH}
                onChange={onChangeTextField('agencyRecruiterName')}
                fullWidth
              />
            </Fieldset>

            <Col>
            </Col>

          </Box>

          <Box row>

            <Fieldset>
              <Button
                label={
                  validatingConnection
                    ? "VALIDATING..."
                    : "VALIDATE CONNECTION"
                }
                title={isAtsValidateConnectionDisabled
                  ? 'Disabled'
                  : null
                }
                className="mt-2"
                onClick={onClickValidateConnectionButton}
                disabled={isAtsValidateConnectionDisabled}
              />
            </Fieldset>

            {isAtsUserInfoAvailable && (
              <Fieldset
                title={
                  <Label className='tt-none'>
                    User info
                  </Label>
                }
              >
                <small>
                  <b>Name: </b>{VALUE__ATS__USER__NAME__GH}<br />
                  {VALUE__ATS__USER__EMAIL__GH && (
                    <>
                      <b>Email: </b>{VALUE__ATS__USER__EMAIL__GH}
                    </>
                  )}
                </small>
                {VALUE__ATS__USER__DISABLED__GH && (
                  <small>
                    &nbsp;|&nbsp;
                    <b className="c-red uppercase">Disabled</b>
                  </small>
                )}
              </Fieldset>
            )}

          </Box>

        </>
      )}

    </Box>
  );
}
